import { Outlet, createFileRoute, useLocation } from "@tanstack/react-router";

// Shared layout for the post-invite onboarding steps (2–4).
// Step 1 (sign-up) lives outside _authed at /invite/$token.

export const Route = createFileRoute("/_authed/onboarding")({
  component: OnboardingLayout,
});

const STEP_MAP: Record<string, number> = {
  "/onboarding/channels": 2,
  "/onboarding/language": 3,
  "/onboarding/first-meeting": 4,
};

const TOTAL_STEPS = 4;

function OnboardingLayout() {
  const path = useLocation({ select: (l) => l.pathname });
  const currentStep = STEP_MAP[path] ?? 2;

  return (
    <div className="min-h-screen bg-[color:var(--color-bg,#f8fafc)]">
      <header className="flex h-14 items-center border-b border-[color:var(--color-abyssal)]/8 bg-white px-6">
        <div className="flex items-center gap-2">
          <div className="flex h-7 w-7 items-center justify-center rounded-lg bg-[color:var(--color-north-star)]">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M3 4h8M3 7h5M3 10h6" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
          </div>
          <span className="font-semibold text-[color:var(--color-abyssal)]">Jotty</span>
        </div>

        <div className="ml-auto flex items-center gap-3">
          <div className="flex gap-1.5">
            {Array.from({ length: TOTAL_STEPS }).map((_, i) => (
              <div
                key={i}
                className={`h-1 rounded-full transition-all ${
                  i + 1 === currentStep
                    ? "w-6 bg-[color:var(--color-north-star)]"
                    : i + 1 < currentStep
                      ? "w-4 bg-[color:var(--color-north-star)]/40"
                      : "w-4 bg-[color:var(--color-abyssal)]/10"
                }`}
              />
            ))}
          </div>
          <span className="text-xs text-[color:var(--color-abyssal)]/50">
            Step {currentStep} of {TOTAL_STEPS}
          </span>
        </div>
      </header>

      <Outlet />
    </div>
  );
}